import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const NAV_ITEMS = [
    { label: "About", to: "/about" },
    {
        label: "Security Testing",
        children: [
            { label: "Network Penetration Testing", to: "/services/network-penertration", icon: "🛡️" },
            { label: "Web Application Penetration Testing", to: "/services/web-application-penetration", icon: "🌐" },
            { label: "Vulnerability Assessment & Penetration Testing", to: "/services/vulnerability-assessment", icon: "🔍" },
            { label: "Mobile App Penetration Testing", to: "/services/mobile-app", icon: "📱" },
            { label: "API Penetration Testing", to: "/services/api-penetration", icon: "🔗" },
        ],
    },
    {
        label: "Cyber Risk Management",
        children: [
            { label: "ISO 27001 Consulting", to: "/services/iso-27001", icon: "📋" },
            { label: "SIA (NESA) Consulting", to: "/services/sia-consulting", icon: "🏛️" },
            { label: "ADHICS Compliance Consulting", to: "/services/adhics-compliance", icon: "✅" },
            { label: "UAE Information Assurance Regulation Audit", to: "/services/uae-information", icon: "🇦🇪" },
        ],
    },
    {
        label: "Managed Services",
        children: [
            { label: "Managed Security Services", to: "/services/managed-security", icon: "🔒" },
            { label: "Security Operations Centre", to: "/services/security-operations", icon: "📡" },
            { label: "Annual Security Program", to: "/services/annual-security", icon: "📅" },
        ],
    },
];

const HeaderNavbar = () => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const [scrolled, setScrolled] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const [mobileExpanded, setMobileExpanded] = useState(null);
    const location = useLocation();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 20);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        setMobileOpen(false);
        setOpenDropdown(null);
    }, [location]);

    const navStyle = {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 1000,
        transition: "all 0.3s ease",
        background: scrolled
            ? "rgba(6, 11, 20, 0.95)"
            : "rgba(6, 11, 20, 0.6)",
        backdropFilter: "blur(16px)",
        WebkitBackdropFilter: "blur(16px)",
        borderBottom: scrolled
            ? "1px solid rgba(59,130,246,0.2)"
            : "1px solid rgba(255,255,255,0.05)",
        boxShadow: scrolled ? "0 4px 30px rgba(0,0,0,0.4)" : "none",
    };

    const linkStyle = {
        color: "#CBD5E1",
        textDecoration: "none",
        fontSize: "17px",
        fontWeight: "500",
        padding: "8px 16px",
        borderRadius: "8px",
        transition: "color 0.2s, background 0.2s",
        display: "flex",
        alignItems: "center",
        gap: "4px",
        whiteSpace: "nowrap",
        cursor: "pointer",
        background: "none",
        border: "none",
        letterSpacing: "0.01em",
    };

    const dropdownMenuStyle = {
        position: "absolute",
        top: "calc(100% + 12px)",
        left: "50%",
        transform: "translateX(-50%)",
        minWidth: "280px",
        background: "rgba(10, 16, 30, 0.98)",
        border: "1px solid rgba(59,130,246,0.18)",
        borderRadius: "14px",
        boxShadow: "0 24px 60px rgba(0,0,0,0.6), 0 0 0 1px rgba(59,130,246,0.08)",
        padding: "8px",
        zIndex: 2000,
        backdropFilter: "blur(20px)",
        overflow: "hidden",
    };

    const dropdownItemStyle = {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "11px 16px",
        borderRadius: "9px",
        color: "#94A3B8",
        textDecoration: "none",
        fontSize: "15px",
        fontWeight: "450",
        transition: "background 0.15s, color 0.15s",
        lineHeight: "1.4",
    };

    const caretStyle = {
        display: "inline-block",
        width: "10px",
        height: "10px",
        borderRight: "2px solid currentColor",
        borderBottom: "2px solid currentColor",
        transform: "rotate(45deg)",
        marginTop: "-4px",
        marginLeft: "2px",
        opacity: 0.6,
    };

    return (
        <>
            <nav style={navStyle}>
                <div className="container" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 24px", height: "72px" }}>

                    {/* Logo */}
                    <Link to="/" style={{ textDecoration: "none", flexShrink: 0 }}>
                        <img
                            src={require("../assets/images/logo-check.webp")}
                            style={{ height: "64px", display: "block" }}
                            alt="Cyber Fortify logo"
                        />
                    </Link>

                    {/* Desktop nav */}
                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }} className="d-none d-lg-flex">
                        {NAV_ITEMS.map((item) =>
                            item.children ? (
                                <div
                                    key={item.label}
                                    style={{ position: "relative" }}
                                    onMouseEnter={() => setOpenDropdown(item.label)}
                                    onMouseLeave={() => setOpenDropdown(null)}
                                >
                                    <button
                                        style={{
                                            ...linkStyle,
                                            color: openDropdown === item.label ? "#60A5FA" : "#CBD5E1",
                                            background: openDropdown === item.label ? "rgba(59,130,246,0.08)" : "none",
                                        }}
                                    >
                                        {item.label}
                                        <span style={{ ...caretStyle, transform: openDropdown === item.label ? "rotate(-135deg)" : "rotate(45deg)", marginTop: openDropdown === item.label ? "2px" : "-4px", color: openDropdown === item.label ? "#60A5FA" : "currentColor", transition: "transform 0.2s" }} />
                                    </button>

                                    {openDropdown === item.label && (
                                        <>
                                            {/* Invisible bridge covering the gap between button and menu so hover doesn't drop */}
                                            <div style={{ position: "absolute", top: "100%", left: 0, right: 0, height: "12px", background: "transparent" }} />
                                            <div style={dropdownMenuStyle}>
                                            {/* Top accent line */}
                                            <div style={{ position: "absolute", top: 0, left: "20%", right: "20%", height: "2px", background: "linear-gradient(90deg, transparent, #3B82F6, transparent)", borderRadius: "2px" }} />
                                            <div style={{ paddingTop: "4px" }}>
                                                {item.children.map((child) => (
                                                    <Link
                                                        key={child.to}
                                                        to={child.to}
                                                        style={dropdownItemStyle}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.background = "rgba(59,130,246,0.1)";
                                                            e.currentTarget.style.color = "#E2E8F0";
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.background = "transparent";
                                                            e.currentTarget.style.color = "#94A3B8";
                                                        }}
                                                        onClick={() => setOpenDropdown(null)}
                                                    >
                                                        <span>{child.label}</span>
                                                    </Link>
                                                ))}
                                            </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            ) : (
                                <Link key={item.to} to={item.to} style={linkStyle}
                                    onMouseEnter={(e) => { e.currentTarget.style.color = "#60A5FA"; e.currentTarget.style.background = "rgba(59,130,246,0.08)"; }}
                                    onMouseLeave={(e) => { e.currentTarget.style.color = "#CBD5E1"; e.currentTarget.style.background = "none"; }}
                                >
                                    {item.label}
                                </Link>
                            )
                        )}

                        {/* Contact CTA */}
                        <Link
                            to="/contact-us"
                            style={{ marginLeft: "8px", padding: "10px 24px", background: "linear-gradient(135deg, #3B82F6, #6366F1)", color: "#fff", borderRadius: "10px", textDecoration: "none", fontSize: "17px", fontWeight: "600", letterSpacing: "0.02em", transition: "opacity 0.2s, transform 0.2s", display: "inline-block" }}
                            onMouseEnter={(e) => { e.currentTarget.style.opacity = "0.85"; e.currentTarget.style.transform = "translateY(-1px)"; }}
                            onMouseLeave={(e) => { e.currentTarget.style.opacity = "1"; e.currentTarget.style.transform = "translateY(0)"; }}
                        >
                            Contact
                        </Link>
                    </div>

                    {/* Mobile hamburger */}
                    <button
                        className="d-lg-none"
                        onClick={() => setMobileOpen(!mobileOpen)}
                        style={{ background: "none", border: "1px solid rgba(59,130,246,0.3)", borderRadius: "8px", padding: "8px 12px", cursor: "pointer", display: "flex", flexDirection: "column", gap: "5px" }}
                        aria-label="Toggle menu"
                    >
                        {[0, 1, 2].map((i) => (
                            <span key={i} style={{ display: "block", width: "22px", height: "2px", background: "#60A5FA", borderRadius: "2px", transition: "all 0.2s",
                                transform: mobileOpen && i === 0 ? "rotate(45deg) translate(5px, 5px)" : mobileOpen && i === 2 ? "rotate(-45deg) translate(5px, -5px)" : "none",
                                opacity: mobileOpen && i === 1 ? 0 : 1,
                            }} />
                        ))}
                    </button>
                </div>

                {/* Mobile menu */}
                {mobileOpen && (
                    <div style={{ background: "rgba(6,11,20,0.98)", borderTop: "1px solid rgba(59,130,246,0.15)", padding: "12px 20px 20px" }}>
                        {NAV_ITEMS.map((item) =>
                            item.children ? (
                                <div key={item.label}>
                                    <button
                                        onClick={() => setMobileExpanded(mobileExpanded === item.label ? null : item.label)}
                                        style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 8px", background: "none", border: "none", color: "#CBD5E1", fontSize: "17px", fontWeight: "500", cursor: "pointer", borderBottom: "1px solid rgba(255,255,255,0.05)" }}
                                    >
                                        {item.label}
                                        <span style={{ fontSize: "12px", color: "#60A5FA" }}>{mobileExpanded === item.label ? "▲" : "▼"}</span>
                                    </button>
                                    {mobileExpanded === item.label && (
                                        <div style={{ paddingLeft: "12px", paddingBottom: "4px" }}>
                                            {item.children.map((child) => (
                                                <Link key={child.to} to={child.to} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px 8px", color: "#94A3B8", textDecoration: "none", fontSize: "15px", borderBottom: "1px solid rgba(255,255,255,0.03)" }}
                                                    onClick={() => setMobileOpen(false)}>
                                                    {child.label}
                                                </Link>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <Link key={item.to} to={item.to} style={{ display: "block", padding: "12px 8px", color: "#CBD5E1", textDecoration: "none", fontSize: "17px", fontWeight: "500", borderBottom: "1px solid rgba(255,255,255,0.05)" }}
                                    onClick={() => setMobileOpen(false)}>
                                    {item.label}
                                </Link>
                            )
                        )}
                        <Link to="/contact-us" style={{ display: "block", marginTop: "16px", padding: "12px 24px", background: "linear-gradient(135deg, #3B82F6, #6366F1)", color: "#fff", borderRadius: "10px", textDecoration: "none", fontSize: "17px", fontWeight: "600", textAlign: "center" }}
                            onClick={() => setMobileOpen(false)}>
                            Contact
                        </Link>
                    </div>
                )}
            </nav>

            {/* Spacer so content doesn't hide under fixed nav */}
            <div style={{ height: "72px" }} />
        </>
    );
};

export default HeaderNavbar;
